'use client';

import { Mail, Sparkles, ArrowRight, Check } from 'lucide-react';
import { useState } from 'react';

export default function SurInvitation() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setSent(true);
      setTimeout(() => {
        setSent(false);
        setEmail('');
      }, 4000);
    }
  };

  return (
    <section
      id="sur-invitation"
      className="relative py-24 sm:py-32 bg-[#0a0a0f] border-t border-[#D4AF37]/10 overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="/images/sur-invitation.png"
          alt="Salon privé de la boutique MATAR"
          className="w-full h-full object-cover"
          style={{ filter: 'brightness(0.45) saturate(1.1)' }}
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              'linear-gradient(180deg, rgba(10,10,15,0.85) 0%, rgba(10,10,15,0.6) 50%, rgba(10,10,15,0.92) 100%)',
          }}
        />
      </div>

      <div className="relative max-w-4xl mx-auto px-5 sm:px-8 text-center">
        {/* Eyebrow */}
        <div className="flex items-center justify-center gap-3 mb-4">
          <span className="block h-px w-10 bg-[#D4AF37]" />
          <span className="eyebrow">Sur Invitation</span>
          <span className="block h-px w-10 bg-[#D4AF37]" />
        </div>

        {/* Heading */}
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight mb-5">
          <span className="text-gold-gradient">Le Cercle</span>{' '}
          <span className="text-[#F4E8C1]">MATAR</span>
        </h2>

        <p className="max-w-2xl mx-auto text-[#F4E8C1]/70 font-light leading-relaxed mb-3">
          Accès privé aux avant-premières, pièces uniques avant mise en vente,
          invitations aux ventes confidentielles et aux dîners de la maison.
          Le Cercle MATAR est réservé à celles et ceux pour qui le cuir est
          plus qu'une matière.
        </p>

        <p className="font-serif italic text-base text-[#D4AF37]/85 mb-10">
          « L'entrée se mérite. L'appartenance se cultive. »
        </p>

        {/* Newsletter form */}
        <form
          onSubmit={handleSubmit}
          className="max-w-md mx-auto mb-8"
        >
          <div className="flex flex-col sm:flex-row gap-3">
            <div className="relative flex-1">
              <Mail
                size={16}
                className="absolute left-4 top-1/2 -translate-y-1/2 text-[#D4AF37]/60"
              />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="votre@adresse.com"
                required
                className="w-full bg-[#0a0a0f]/80 backdrop-blur-sm border border-[#D4AF37]/30 pl-11 pr-4 py-3.5 text-sm text-[#F4E8C1] placeholder:text-[#F4E8C1]/35 focus:border-[#D4AF37] focus:outline-none transition-colors"
              />
            </div>
            <button
              type="submit"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-gold-gradient text-[#0a0a0f] font-semibold uppercase tracking-[0.18em] text-xs hover:glow-gold transition-all duration-500 whitespace-nowrap"
            >
              {sent ? (
                <>
                  <Check size={14} />
                  Inscription confirmée
                </>
              ) : (
                <>
                  <Sparkles size={14} />
                  Rejoindre le Cercle
                </>
              )}
            </button>
          </div>
        </form>

        {/* Trust line */}
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[10px] uppercase tracking-[0.25em] text-[#F4E8C1]/45 mb-12">
          <span className="flex items-center gap-2">
            <Check size={11} className="text-[#D4AF37]" />
            Confidentialité absolue
          </span>
          <span className="flex items-center gap-2">
            <Check size={11} className="text-[#D4AF37]" />
            Maximum 1 invitation / mois
          </span>
          <span className="flex items-center gap-2">
            <Check size={11} className="text-[#D4AF37]" />
            Désinscription en 1 clic
          </span>
        </div>

        {/* CTA to appointment */}
        <div className="border-t border-[#D4AF37]/15 pt-10">
          <p className="text-sm text-[#F4E8C1]/65 mb-6 font-light">
            Pour une visite privée de l'atelier, un projet sur mesure, ou
            simplement rencontrer le maître :
          </p>
          <a
            href="#contact"
            className="inline-flex items-center justify-center gap-3 px-9 py-4 border border-[#D4AF37]/45 text-[#F4E8C1] font-medium uppercase tracking-[0.18em] text-xs hover:bg-[#D4AF37]/10 hover:border-[#D4AF37] transition-all duration-500"
          >
            Demander une audience privée
            <ArrowRight size={14} />
          </a>
        </div>
      </div>
    </section>
  );
}
